import ReactGA from 'react-ga4'

export const initializeAnalytics = () => {
  ReactGA.initialize('G-VGYGC388ZD')
  console.log('GA initialized')
}

export const sendPageViewAnalytics = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path })
}

export const sendAnalyticsEvent = (name, { category, action, label }) => {
  ReactGA.event(name, { category, action, label })
}
